module.exports = {
  menuHomeLabel: 'Home',
  menuBenefitsLabel: 'Beneficios',
  menuEarningsLabel: 'Ganancias como consultora',
  menuOurCausesLabel: 'Consultoría de Belleza',
  menuHelpLabel: 'Preguntas Frecuentes',
  homeId: 'home',
  homeHeroSectionId: 'hero',
  homeHeroCTAButtonText: 'Regístrate aquí',
  homeHeroCTAButtonAccessibleLabel: 'Registrarse',
  homeHeroSubtitle:
    '¡Cuando nos encontramos, nos apoyamos y tu vas más lejos! Únete a la Consultoría de Belleza Natura y Avon y transforma tu vida y el mundo.',
  homeHeroTitle:
    'Vive la belleza del encuentro',
  homeHeroImageAlt: 'Mulher sorrindo segurando um celular. Ao lado esquerdo, produtos da Natura em cima da mesa.',
  homePageTitle: 'Quiero ser Consultora',
  benefitsSectionId: 'beneficios',
  benefitsHeadingTitle: 'Beneficios',
  benefitsHeadingSubtitle:
    'Nuestra Consultoría de Belleza es apasionada por las relaciones humanas y los cosméticos. Mira cuáles son las ventajas para ti:',
  benefitHealthTitle: 'Productos apasionantes',
  benefitHealthText:
    'Ofreces una Consultoría de Belleza llena de innovación y los mejores productos de Natura y Avon, además de las opciones de Casa y Estilo, para deleitar a tus clientes en cualquier momento.',
  benefitEducationTitle: 'Entrenamientos',
  benefitEducationText:
    '¡Aprendes de forma rápida y práctica a vender! Accedes a entrenamientos a cualquier hora del día, organizados y en un solo lugar, para lograr ventas exitosas y aumentar tus ganancias.',
  benefitOnlineSellsTitle: 'Venta Online',
  benefitOnlineSellsText:
    'Puedes vender productos de la marca Natura de forma remota a clientes de todo el país con una tienda online, disponible las 24 horas del día, los 7 días de la semana.',
  benefitBonusTitle: 'Camino de crecimiento',
  benefitBonusText:
    'Conquista más beneficios y aumenta tus ganancias con productos Natura y Avon  evolucionando de nivel (de Bronce a Diamante) en un Camino de Crecimiento hecho para ti. ¡Todas tus ventas suman!',
  benefitRecognitionTitle: 'Reconocimientos',
  benefitRecognitionText:
    '¡Tu jornada es única! Serás reconocida por tu historia y dedicación con Natura y Avon en campañas, concursos, viajes y eventos.',
  benefitRegisterButtonText: 'Regístrate aquí',
  ctaButtonLinkDesktop:
    'https://accounts.natura-avon.com/auto?country=pe&company=natura',
  ctaButtonLinkMobile:
    'https://accounts.natura-avon.com/auto?country=pe&company=natura',
  earningsSectionId: 'ganancias-como-consultora',
  earningsHeadingTitle: 'Ganancias como Consultora',
  earningsHeadingSubtitle:
    'Descubre cuanto podrías ganar con la venta de este Kit de productos de Natura y Avon en Venta por revista y en Venta online.',
  earningsProduct1Title: 'Ekos Castaña: S/. 38',
  earningsProduct1Description: '100% vegano y conserva la Amazonia brasileña',
  earningsProduct2Title: 'Tododia Frutas Rojas',
  earningsProduct2Description: 'Nutrición prebiótica y ingredientes naturales',
  earningsProduct3Title: 'Ekos Frescor Maracuyá: S/. 84',
  earningsProduct3Description:
    'Eau de toilette extraído de las semillas del maracuyá',
  earningsProduct4Title: 'Shampoo Lumina: S/. 26',
  earningsProduct4Description:
    'Biotecnologia pró-teia y frasco de plástico verde',
  earningsCalculatorChartResultText: 'Tu cliente compra este kit por:',
  earningsCalculatorChartResultDescription:
    '{salesType, select, true {El descuento* por ventas a través de revista, de acuerdo a tu nivel es:} false {La ganancia por ventas a través de tu tienda online, de acuerdo a tu nivel es:}}',
  earningsChartLevelSeed: 'Semilla',
  earningsChartLevelBronze: 'Bronce',
  earningsChartLevelSilver: 'Plata',
  earningsChartLevelGold: 'Oro',
  earningsChartLevelDiamond: 'Diamante',
  onlineSalesButtonText: 'Ventas Online',
  regularSalesButtonText: 'Ventas por revista',
  ourCausesSectionId: 'nuestras-causas',
  ourCausesHeadingTitle: 'Consultoría de Belleza',
  ourCausesHeadingSubtitle: 'Nuestra Consultoría cree que el poder de venta por relación es el secreto del éxito. Juntas, transformamos el mundo, y con Natura y Avon, tú puedes lograr mucho más:',
  ourCausesAmazonTitle: 'Amazonía Viva',
  ourCausesAmazonText:
    '¡Incluye los productos Natura, Avon y de Casa y Estilo en un solo pedido, recíbelos todos en la misma caja y paga una única boleta! Simple, ¿no? <br/>Con pedidos, pagos e incluso entrenamientos organizados en un solo lugar, tiene todo el apoyo para dar lo mejor de sí y brillar en el negocio.',
  ourCausesRecyclingTitle: 'Más belleza, menos residuos',
  ourCausesRecyclingText:
    'Puedes sumar puntos con productos de ambas marcas para el Camino de Crecimiento, lo que acelera su desarrollo y su desenvolvimiento como Consultora de Belleza. <br/>Son más las posibilidades de ganancias, independencia para su rutina, aprendizajes y ventajas, ¡todo para que pueda expandir sus ventas y obtener muchos más beneficios!',
  phone: '01-311-0031',
  helpSectionId: 'preguntas-frecuentes',
  helpHeadingTitle: 'Preguntas Frecuentes',
  footerTitle: 'Vea también',
  footerCallCenterLabel: 'SAC',
  footerCopyRightLabel: 'Todos los derechos reservados.'
}
